import { MEMBERSHIP_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { IMembershipListingResponse } from "@/api_framework/api_modals/Membership";
import { setMembershipList } from "@/app_redux/reducers/slices/auth/membership.slice";

AxiosCurlirize(axios, () => {});

export const useMembershipListingAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (search?: string, source?: string) => { 
      dispatch(
        setLoading({
          key: "isMembershipSetupListInProgress",
          status: true,
        }),
      );
      let MEMBERSHIP_LIST_API = null;
      if (search && source) {
        MEMBERSHIP_LIST_API = `${MEMBERSHIP_MODULE?.MEMBERSHIP_LISTING_API?.baseURL}?search=${search}&source=${source}`;
      } else if (search) {
        MEMBERSHIP_LIST_API = `${MEMBERSHIP_MODULE?.MEMBERSHIP_LISTING_API?.baseURL}?search=${search}`;
      } else if (source) {
        MEMBERSHIP_LIST_API = `${MEMBERSHIP_MODULE?.MEMBERSHIP_LISTING_API?.baseURL}?source=${source}`;
      } else {
        MEMBERSHIP_LIST_API = `${MEMBERSHIP_MODULE?.MEMBERSHIP_LISTING_API?.baseURL}`;
      }

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(MEMBERSHIP_LIST_API, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IMembershipListingResponse>) => {
            if (res.data.status === true) {
              dispatch(setMembershipList({ data: res?.data?.data }));
              dispatch(
                setLoading({
                  key: "isMembershipSetupListInProgress",
                  status: false,
                }),
              );
            } else {
              dispatch(
                setLoading({
                  key: "isMembershipSetupListInProgress",
                  status: false,
                }),
              );
              dispatch(setMembershipList({ data: [] }));
            }
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isMembershipSetupListInProgress",
                status: false,
              }),
            );
            dispatch(setMembershipList({ data: [] }));
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              //   toast("Product records not found");
            }
            if (e.response.status === 500) {
              // toast.error("Server error 500");
            }
          });
      } catch (error) {
        dispatch(
          setLoading({
            key: "isMembershipSetupListInProgress",
            status: false,
          }),
        );
        dispatch(setMembershipList({ data: [] }));
      }
    },
    [dispatch, configuration],
  );
  return { execute };
};
